/**
 * LogsTab — user activity log. All behavior lives in the shared
 * ProfileLogsTable; this only supplies what differs per entity.
 *
 * Users link the actor to their profile, same as devices. Rows fall back to
 * `source` when there is no structured log_info, which is what distinguishes
 * an admin-initiated password reset from a self-service one.
 */

import ProfileLogsTable from '../../../../components/v2/ProfileLogsTable.jsx';

const LogsTab = ({ logData, tzOffset, showInternal = true }) => (
  <ProfileLogsTable
    logData={logData}
    tzOffset={tzOffset}
    typeKey="user_log_type"
    title="User Logs"
    linkUsers
    detailFallbackKey="source"
    showInternal={showInternal}
  />
);

export default LogsTab;
